import { render } from "./BranchUsersItem.vue?vue&type=template&id=6adf6fd9&scoped=true"
import script from "./BranchUsersItem.vue?vue&type=script&lang=js"
export * from "./BranchUsersItem.vue?vue&type=script&lang=js"

import "./BranchUsersItem.vue?vue&type=style&index=0&id=6adf6fd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adf6fd9"]])

export default __exports__